var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3 mt-3",staticStyle:{"min-height":"690px"}},[_c('h1',{staticClass:"text-xl text-left font-bold flex mb-2"},[_vm._v(" Admins ")]),_c('div',{staticClass:"border mb-2"}),_c('Admins')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }